module.exports = "/_next/static/images/UnifyCustomerProfileMobile@2x-a12720d1c8895c3740a7fdc373ae7541.webp";